<template>
  <div>
    <app-header></app-header>

    <div class="layout-w">
      <app-menu v-if="empresa"></app-menu>
      <div class="content-w">
        <div v-if="!empresa && isAdministrador && !isNovaEmpresa" class="content-w">
          <div class="no-results">
              <div class="big-error-w" style="margin-bottom: 100px;">
                  <h4>
                    Defina a empresa para Gerenciar
                  </h4>
                  <div class="row">
                    <div class="col">
                      <app-list-empresa></app-list-empresa>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <small>OU</small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col m-2">
                      <button type="button" class="btn btn-secondary btn-lg btn-block"
                        @click="buildNovaEmpresa">Criar Nova Empresa</button>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <transition v-else name="content" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/components/Menu'
import Header from '@/components/Header'
import ListEmpresa from '@/components/listEmpresa'

export default {
  computed:{
    empresa() {
      return this.$store.getters.empresa;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    }
  },
  components: {
    'app-menu': Menu,
    'app-header': Header,
    'app-list-empresa': ListEmpresa
  },
  data(){
    return {
      isNovaEmpresa: false
    }
  },
  methods: {
    buildNovaEmpresa() {
      this.isNovaEmpresa = true;
      this.$router.push({name: 'EmpresaForm'});
    }
  }
}

</script>
